<template>
  <v-menu
    content-class="notification-menu"
    :offset-y="offset"
    v-model="notificationMenu"
    style="display: block;"
    :close-on-content-click="false"
    :close-on-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        class="bell-wrapper d-flex align-center justify-center"
        v-bind="attrs"
        v-on="on"
      >
        <transition name="fade">
          <v-badge
            :value="total_not_read && total_not_read > 0"
            bottom
            color="redLight"
            offset-x="14"
            offset-y="33"
            :content="total_not_read"
          >
            <v-icon class="icon-tam-29" color="grayVibrant">$bellIcon</v-icon>
          </v-badge>
        </transition>
      </div>
    </template>

    <div class="box-notification">
      <div class="d-flex justify-space-between px-4 pt-4 mb-6">
        <div
          class="d-flex gp-16 align-center fonts-s20 fonts-600 fonts-color-dark fonts-family-poppins"
        >
          Notificaciones
          <span
            class="badge-custom rounded-circle redLight fonts-s10 fonts-700 fonts-family-DMSans white--text"
            >{{ total_not_read }}</span
          >
        </div>
        <v-btn
          @click="
            () => {
              notificationMenu = false;
            }
          "
          icon
          class="pa-2 custom-btn-round-size40"
        >
          <v-icon>$closeIcon</v-icon>
        </v-btn>
      </div>
      <div
        class="notification-scroll-container"
        ref="scrollContainer"
        @scroll="throttledScroll"
        style="max-height: 840px; height: calc(100vh - 80px); overflow-y: auto;"
      >
        <v-list v-if="total_valid > 0" class="py-0">
          <template v-for="(item, index) in new_request_notifications">
            <v-list-item class="pa-4 item-notification" :key="index">
              <div class="flex-grow-1">
                <div class="d-flex justify-space-between align-center">
                  <div
                    class="fonts-s16 fonts-color-dark fonts-600 fonts-family-poppins text-truncate"
                  >
                    {{ item.title }}
                    <span
                      class="ml-2 fonts-s12 fonts-400 fonts-color-gray3 fonts-family-poppins"
                      >{{ formatDateTime(item.created__at).time }} hs</span
                    >
                  </div>
                  <div
                    :class="
                      `badge-custom-mini badge-custom-mini-${
                        item.is_read ? 'green' : 'red'
                      }`
                    "
                  ></div>
                </div>
                <v-btn
                  text
                  small
                  class="pa-0 h-custom-25"
                  @click="redirectToNotification(item)"
                >
                  <span class="fonts-s14 fonts-500 fonts-color-dark2">
                    Ver detalle
                  </span>
                </v-btn>

                <div
                  class="text-end fonts-s12 fonts-color-gray3 fonts-family-poppins"
                >
                  {{ formatDateTime(item.created__at).date }}
                </div>
              </div>
            </v-list-item>
          </template>
        </v-list>
      </div>
    </div>
  </v-menu>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import throttle from "lodash/throttle";
export default {
  name: "notificationMenu",
  mounted() {
    this.throttledScroll = throttle(this.handleScroll, 300);
  },
  data() {
    return {
      offset: true,
      page: 1,
      limit: 10,
      notificationMenu: false,
    };
  },
  computed: {
    ...mapState({
      new_request_notifications: (state) =>
        state["Notifications_request_cms"].list_valid,
      total_valid: (state) => state["Notifications_request_cms"].total_valid,
      total_not_read: (state) =>
        state["Notifications_request_cms"].total_not_read,
    }),
  },
  methods: {
    notificationPagePrev() {
      this.page = this.page > 1 ? this.page - 1 : 1;
      this.$store.dispatch(
        "Notifications_request_cms/getListAllNotifications",
        {
          notification: "enable",
          is_read: false,
          is_new: true,
          page: this.page,
          limit: this.limit,
        }
      );
    },
    formatDateTime(date_time) {
      const date = new Date(date_time);
      const localDate = moment.utc(date).local();
      return {
        date: localDate.format("DD/MM/YYYY"),
        time: localDate.format("HH:mm"),
      };
    },
    getUserInitials(user) {
      if (user) {
        const complete_name = `${user.name || ""} ${user.last_name ||
          ""}`.trim();
        const nameParts = complete_name.split(" ");
        return nameParts
          .map((part) => part.charAt(0))
          .join("")
          .toUpperCase();
      }
      return "";
    },
    redirectToNotification(item) {
      this.$store.dispatch("Notifications_cms/show", item.id).then(() => {
        this.$store.dispatch(
          "Notifications_request_cms/getListAllNotifications",
          {
            notification: "enable",
            is_read: false,
            is_new: true,
            page: this.page,
            limit: this.limit,
          }
        );
      });

      if (item.type_notification === "new_spot") {
        this.$router
          .push("/admin/notifications_cms/edit/" + item.spot_id)
          .catch(() => {});
      } else if (item.type_notification === "new_spot_help") {
        this.$router
          .push("/admin/spot_helps/show/" + item.spot_help_id)
          .catch(() => {});
      } else if (item.type_notification === "cms-notification-extraction") {
        this.$router
          .push("/admin/request_extraction/edit/" + item.request_extraction_id)
          .catch(() => {});
        this.$store.dispatch("Notifications_request_cms/show", item.id);
      } else if (item.type_notification === "cms-need-sticker") {
        this.$router
          .push("/admin/notifications_request_cms/show/" + item.id)
          .catch(() => {});
      }
    },
    notificationPage() {
      this.page = this.page + 1;
      this.$store.dispatch(
        "Notifications_request_cms/getListAllNotifications",
        {
          notification: "enable",
          is_read: false,
          is_new: true,
          page: this.page,
          limit: this.limit,
        }
      );
    },
    handleScroll() {
      const el = this.$refs.scrollContainer;
      if (!el) return;

      const bottomReached =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 5;
      if (bottomReached) {
        this.notificationPage();
      }
    },
    throttledScroll: throttle(function (event) {
      this.handleScroll(event);
    }, 300)
  },
};
</script>
